import React from 'react';

// Using React.SVGProps for better type checking on SVG attributes
type StarIconProps = React.SVGProps<SVGSVGElement>;

const StarIcon: React.FC<StarIconProps> = (props) => (
  <svg viewBox='-2 -2 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='m14 22.025-6.838 3.57a1.297 1.297 0 0 1-1.88-1.366l1.282-7.607-5.508-5.4a1.297 1.297 0 0 1 .718-2.21l7.63-1.131L12.838.974a1.297 1.297 0 0 1 2.324 0l3.434 6.907 7.63 1.131a1.298 1.298 0 0 1 .718 2.21l-5.508 5.4 1.282 7.607a1.298 1.298 0 0 1-1.88 1.366z' />
  </svg>
);

export default StarIcon;
